<template>
  <div>
    <div class="query-control">
      <el-form ref="form" label-width="100px" label-position="left" size="mini">
<!--        <el-form-item label="标的使用范围/位置">-->
<!--          <el-input placeholder="请输入" v-model="value.location"  clearable></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="价格">
          <div class="flex">
            <el-input  v-model="value.start" clearable>
              <template slot="prepend">¥</template>
            </el-input>
             <span>-</span>
            <el-input v-model="value.end" clearable>
              <template slot="prepend">¥</template>
            </el-input>
            <el-button  type="primary" @click="InquireList">确定</el-button>
          </div>
        </el-form-item>
        <el-form-item label="标的类型">
          <el-radio-group size="small" v-model="value.businessType" @change="InquireList">
            <el-radio v-for="item of targetType" :key="item.businessType" :label="item.businessType" border >{{item.businessTypeDesc}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标的状态">
          <span class="transfer-type" v-if="isOffline == 1">已成交</span>
          <el-radio-group size="small" v-model="value.newStatus" @change="InquireList" v-else>
            <el-radio v-for="item of status"  :key="item.name" :label="item.value" border>{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="交易方式">
          <span class="transfer-type" v-if="transferType == 1">网络竞价</span>
          <el-radio-group size="small" v-model="value.transferType" @change="InquireList" v-else>
            <el-radio  v-for="item of projectProperties" :key="item.name" :label="item.value" border >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="query-price">
      <div class="left-content">
        <div class="current-record">当前记录 {{total}} 条</div>
      </div>
    </div>
  </div>
</template>

<script>
import { sessionStore } from "@/utils/data-management";
export default {
  props: {
    value: Object,
    required: true,
    total: { type: Number, default: 0 },
    transferType: { type: Number, default: 0}, // 默认全部，1-网络竞价
    isOffline: { type: Number, default: 0} // 默认全部，1-网络竞价
  },
  data() {
    return {
      targetType: [],
      // status: [
      //   {
      //     name: "全部",
      //     value: ""
      //   },
      //   {
      //     name: "挂牌中",
      //     value: 3
      //   },
      //   {
      //     name: "已摘牌",
      //     value: 4
      //   },
      //   {
      //     name: "未成交",
      //     value: 5
      //   },
      //   {
      //     name: "已成交",
      //     value: 6
      //   },
      //   {
      //     name: "竞价结束",
      //     value: 10
      //   },
      //   {
      //     name: "已交易",
      //     value: 11
      //   },
      //   {
      //     name: "交易完成",
      //     value: 12
      //   },
      //   {
      //     name: "交易取消",
      //     value: 13
      //   },
      // ],
      status: [
        {
          name: "全部",
          value: ""
        },
        {
          name: "未开始",
          value: 0
        },
        {
          name: "报名中",
          value: 1
        },
        {
          name: "即将竞价",
          value: 2
        },
        {
          name: "竞价中",
          value: 3
        },
        {
          name: "已成交",
          value: 4
        },
        {
          name: "未成交",
          value: 5
        },
      ],
      projectProperties: [
        {
          name: "全部",
          value: ""
        },
        {
          name: "网络竞价",
          value: 1
        },
        {
          name: "协议转让",
          value: 2
        },
        {
          name: "预售",
          value: 3
        }
      ],
      areaList:[],
    };
  },
  methods: {
    InquireList() {
      // if (!this.$store.state.token || this.$store.state.token == 'show') {
      //   this.$store.dispatch("getToken", "show");
      // } else {
        this.$parent.searchData();
      // }
    },
    init() {
      this.$api.my.getBusinessTypeInfo({}).then((res) => {
        this.targetType = res.data
        this.targetType.unshift({businessType: '',businessTypeDesc: "全部"})
      })
    },
  },
  created(){
    this.init()
  }
};
</script>
<style lang="scss" scoped>
.query-control {
  background: #fff;
  padding: 20px;
  .title {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(168, 170, 174, 1);
    line-height: 12px;
    margin: 0 0 26px;
  }
  .el-form {
    .el-form-item {
      &:last-child {
        /deep/ .el-form-item__content {
          border: none;
        }
      }
      /deep/ .el-form-item__label {
        line-height: 40px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(57, 66, 89, 1);
      }
      /deep/ .el-form-item__content {
        border-bottom: 1px dashed #ebecef;
        .transfer-type {
          padding: 0 6px;
          font-size: 12px;
          color: #606266;
        }
      }
      .el-radio-group {
        .el-radio {
          border-radius: 10px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          padding: 4px 6px;
          height: auto;
          border: none;
          margin-right: 10px;
          &.is-checked {
            color: rgba(246, 82, 72, 1);
            background: rgba(245, 246, 246, 1);
          }
          /deep/ .el-radio__input {
            display: none;
          }
          /deep/ .el-radio__label {
            padding: 0;
          }
        }
      }
      .el-input {
        width: 200px;
      }
    }
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
    /deep/ .el-form-item--mini .el-form-item__content {
      line-height: 40px;
    }
  }
}
.query-price {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(96, 105, 126, 1);
  line-height: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 18px 0px;
  .left-content {
    display: flex;
    align-items: center;
  }
  }
  .current-record {
    margin-right: 20px;
  }
  .flex{
    display: flex;
    align-items: center;
    .el-button{
      margin-left: 20px;
    }
    span{
      margin: 0 10px;
    }
  }

</style>
